import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Router, NavigationEnd } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { Subject } from 'rxjs';
import { takeUntil, filter } from 'rxjs/operators';
import { NavigationService } from '../../shared/services/navigation.service';
import { NavigationItem } from '../../shared/data/navigation.data';
import { FlamingoAuthService } from '../../../@flamingo/service/flamingo-auth.service';

@Component({
    selector: 'app-main-layout',
    templateUrl: './main-layout.component.html',
    styleUrls: ['./main-layout.component.scss'],
    standalone: true,
    imports: [CommonModule, RouterModule, MatIconModule, MatMenuModule, MatButtonModule, MatButtonToggleModule]
})
export class MainLayoutComponent implements OnInit, OnDestroy {
    navigation: NavigationItem[] = [];
    isAuthenticated = false;
    isProfileRoute = false;

    private _unsubscribeAll: Subject<any>;

    constructor(
        private _navigationService: NavigationService,
        private _authService: FlamingoAuthService,
        private _router: Router
    ) {
        this._unsubscribeAll = new Subject();
    }

    ngOnInit(): void {
        // Check authentication status
        this.updateAuthenticationStatus();

        // Subscribe to navigation changes
        this._navigationService.navigation$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((navigation: NavigationItem[]) => {
                this.navigation = navigation;
            });

        // Listen to router changes to update authentication status
        this._router.events
            .pipe(
                filter(event => event instanceof NavigationEnd),
                takeUntil(this._unsubscribeAll)
            )
            .subscribe(() => {
                this.updateAuthenticationStatus();
                this.isProfileRoute = this._router.url.startsWith('/profile');
            });

    }

    private updateAuthenticationStatus(): void {
        this.isAuthenticated = this._authService.isLogged();

        // Set navigation based on user type if authenticated
        if (this.isAuthenticated && this._authService.user) {
            this._navigationService.setNavigationByUserType(this._authService.user.type);
        }

        console.log('🔧 Authentication status updated:', this.isAuthenticated);
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    onLogout(): void {
        this._authService.logout();
        this._router.navigate(['/auth']);
    }
}
